// extracted by mini-css-extract-plugin
export default {"tag":"HP4zmZSLnbeR2ESLopeC"};